const projectsData = [
  {
    title: 'Tech Garden',
    description: 'Explore the most exciting projects and stay updated with TechGarden.',
    imgSrc: 'https://techgarden.akashrajpurohit.com/twitter-card.png',
    href: 'https://techgarden.akashrajpurohit.com/?ref=akashrajpurohit.com',
  },
  {
    title: 'How to Professionally Say',
    description: 'A guide for your daily "professional" interactions (not really).',
    imgSrc: '/static/images/projects/how-to-professionally-say.png',
    href: 'https://howtoprofessionallysay.akashrajpurohit.com/?ref=akashrajpurohit.com',
  },
  {
    title: 'Github Emojis',
    description: `Search from 1000s of shortcode emojis supported by Github.`,
    imgSrc: '/static/images/projects/github-emojis.png',
    href: 'https://github.com/AkashRajpurohit/github-emojis/?ref=akashrajpurohit.com',
  },
  {
    title: 'Clipper',
    description: `Save history of all information you copy and use them whenever with a solitary snap.`,
    imgSrc: '/static/images/projects/clipper.png',
    href: 'https://github.com/AkashRajpurohit/clipper/?ref=akashrajpurohit.com',
  },
  // {
  //   title: 'EZLyrics',
  //   description: `EZLyrics is an application which will help you find lyrics and well as save them offline for later.`,
  //   imgSrc: '/static/images/projects/ezlyrics.png',
  //   href: 'https://play.google.com/store/apps/details?id=com.akash.ezlyrics.full',
  // },
  {
    title: 'Word Hunt',
    description: 'Mind game of a kind 🤯',
    imgSrc: '/static/images/projects/wordhunt.png',
    href: 'https://wordhunt.fly.dev/?ref=akashrajpurohit.com',
  },
  {
    title: 'Giffy',
    description: 'Easy GIF finder for desktop',
    imgSrc: '/static/images/projects/giffy.jpeg',
    href: 'https://github.com/AkashRajpurohit/giffy/?ref=akashrajpurohit.com',
  },
  {
    title: 'LexiContext',
    description: `A service to calculate the semantic similarity between a pair of sentence.`,
    imgSrc: '/static/images/projects/lexicontext.png',
    href: 'https://lexicontext.netlify.app/?ref=akashrajpurohit.com',
  },
  {
    title: 'Currency Converter',
    description: `A free, open-source, minimalist's UI designed, currency converter app.`,
    imgSrc: '/static/images/projects/currency-converter.png',
    href: 'https://github.com/AkashRajpurohit/Currency-Converter/?ref=akashrajpurohit.com',
  },
]

export default projectsData
